module.exports = __webpack_public_path__ + "static/media/Viastara.5f28aad2.svg";